import { get } from 'lodash'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { clearCart } from '../../actions/cart'
import { setActiveCustomer } from '../../actions/suites/customer'
import { setActiveRevenueCenter } from '../../actions/revenueCenter'
import { orderDetailsRequested } from '../../actions/order'

import { getIsSuitesMode } from '../../selectors/config'
import { makeGetCustomerTabOrders, makeGetTabOrders } from '../../selectors/order'
import {
  getHighlightedIds,
  getFocusedItemId,
  getSearchQuery,
} from '../../selectors/search'

import TabOrdersList from '../../components/tabs/TabOrdersList'

import { TabOrderRowsViewModel } from '../../viewmodels/TabOrdersViewModel'
import { clearPromotionsOnOrder } from '../../actions/promotion'

const mapStateToProps = (state, ownProps) => {
  const getCustomerTabOrders = makeGetCustomerTabOrders()
  const getTabOrders = makeGetTabOrders()

  const customerId = get(ownProps, 'customerId')
  const revenueCenterId = get(ownProps, 'revenueCenterId')

  let orders = []
  if (customerId !== undefined) {
    orders = TabOrderRowsViewModel(getCustomerTabOrders(state, customerId, revenueCenterId))
  } else {
    orders = TabOrderRowsViewModel(getTabOrders(state))
  }

  const isSuites = getIsSuitesMode(state)
  const highlightedIds = getHighlightedIds(state)
  const searchQuery = getSearchQuery(state)
  const focusedItemId = getFocusedItemId(state)

  return { isSuites, orders, highlightedIds, searchQuery, focusedItemId }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const customerId = get(ownProps, 'customerId')
  const replace = get(ownProps, 'history.replace', () => {})
  const revenueCenterId = get(ownProps, 'revenueCenterId')
  const push = ownProps?.history?.push ?? function(){}

  return {
    onSelectOrder: (orderId) => {
      dispatch(setActiveCustomer(customerId))
      dispatch(setActiveRevenueCenter(revenueCenterId))
      dispatch(orderDetailsRequested(orderId))
      replace(`/tab-order/${orderId}`)
    },
    onCloseOrder: (orderId, isMultiPayment) => {
      dispatch(orderDetailsRequested(orderId))

      if (isMultiPayment) {
        push(`/tender/${orderId}`)
      } else {
        push(`/tabs/${orderId}/close`)
      }
    },
    onViewOrder: (orderId) => {
      dispatch(orderDetailsRequested(orderId))
      replace(`/tabs/${orderId}`)
    },
    onMount: () => {
      dispatch(clearCart())
      dispatch(clearPromotionsOnOrder())
    }
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TabOrdersList))
